import { createFileRoute } from "@tanstack/react-router";
import { Home } from "@content";

export const Route = createFileRoute("/")({
    component: Home
});
